<template>
  <div class="apilogs">
    <el-row v-for="log in logs.data" :key="log.name">
      <el-button type="primary" @click="openKibanaVisualization(log.name)">
          {{log.name}}
      </el-button>
    </el-row>
  </div>
</template>2

<style lang="scss">
  .apilogs {
    margin: 20px;
  }
  .apilogs button {
    margin: 10px;
    width: 250px
  }
</style>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      logs: [
        {
        }
      ]
    }
  },
  created: function () {
    this.loadData()
  },
  methods: {
    loadData () {
      window.console.log('loading')
      axios
        .get(`${process.env.API_URL}/apilogs/list`)
        .then(response => (this.logs = response.data))
      window.console.log(this.logs)
    },
    openKibanaVisualization (name) {
      let url = `${process.env.API_URL}/apilogs/visualize?name=${name}&stage=live&jwt=${this.$store.state.auth.token}`
      window.open(url, 'PuchasesAndVouchersPerUser')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/apilogs/apilogs.vue